<div class="complydome-container" [class.sidebar-collapsed]="isSidebarCollapsed"
  [class.notification-collapsed]="isNotificationCollapsed" [class.is-collapsing]="isSidebarCollapsing">
  <!-- Mobile Backdrop -->
  <div class="mobile-backdrop sidebar-backdrop" *ngIf="isMobile && isSidebarVisible" (click)="toggleSidebar()"></div>
  <div class="mobile-backdrop notification-backdrop" *ngIf="isMobile && isNotificationBarVisible"
    (click)="toggleNotificationBar()"></div>
  <!-- Header -->
  <header class="header">
    <button class="burger-menu" type="button" (click)="toggleSidebar()" [class.is-open]="isSidebarVisible"
      [attr.aria-label]="isSidebarVisible ? 'Close menu' : 'Open menu'" [attr.aria-expanded]="isSidebarVisible">
      <i class="fas" [ngClass]="isSidebarVisible ? 'fa-times' : 'fa-bars'"></i>
      <!-- Burger icon for the left navbar -->
    </button>
    <div class="company-logo">
      <img src="assets/complydome-icon.svg" alt="ComplyDome Icon" class="dome-icon" />
      <div class="company-name">
        <span class="comply">comply</span>
        <span class="dome">dome</span>
      </div>
    </div>
    <div class="burger-menu right" (click)="toggleNotificationPanel($event)">
      <i class="fas fa-bell"></i>
      <span class="notification-badge" *ngIf="unreadNotificationCount > 0">
        {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
      </span>
      <!-- Notification icon for the right notification bar -->
    </div>
  </header>

  <!-- Left Sidebar for Navigation, hidden on small screens via CSS -->
  <nav class="navbar" [class.active]="isSidebarVisible">
    <!-- Help Button -->
    <div class="help-button-container" data-collapsed-label="I Need Help">
      <button (click)="displayCreateNewTicketModal()" class="help-button">
        <img src="assets/help-icon.svg" alt="Help Icon" class="custom-help-icon" />
        <span class="help-text">I Need Help</span>
      </button>
    </div>

    <!-- Separator Line After Help Button -->
    <div class="separator-line"></div>

    <!-- Navigation Menu -->
    <ul class="nav-menu" (click)="onNavMenuClick($event)">
      <div class="nav-group">
        <div class="nav-group-label" aria-hidden="true">Daily Operations</div>
      <li
        *appCheckPolicyAny="[policyViewDshGlobal, policyViewDshGeneralView, policyViewDshVendor, policyViewDshEmployee, policyViewDshPolicies, policyViewDshUserAudits, policyViewDshIncidentsNotifications, policyViewDshIncidents, policyViewDshAssets]"
        class="nav-item" data-collapsed-label="Dashboard" [class.active]="pathname.startsWith('/shell/dashboard')">
        <a routerLink="/shell/dashboard" class="nav-link">
          <i class="fas fa-tachometer-alt nav-icon"></i><span class="nav-text">Dashboard</span>
        </a>
      </li>
      <li
        *appCheckPolicyAny="[policyViewMpfGlobal, policyViewMpfViewLicences, policyViewMpfViewAgreements, policyViewMpfViewTrainings, policyViewMpfViewCertitifications, policyViewMpfViewComplianceChecks, policyViewMpfViewAssets]"
        class="nav-item" data-collapsed-label="Portfolio" [class.active]="
          pathname.startsWith('/shell/entity-management/my-compliance')
        ">
        <a routerLink="/shell/entity-management/my-compliance" class="nav-link">
          <i class="fas fa-briefcase nav-icon"></i><span class="nav-text">Portfolio</span>
        </a>
      </li>
      <li *appCheckPolicyAny="[policyViewVendors, policyViewEmployees]" class="nav-item"
        data-collapsed-label="Employees &amp; Vendors" [class.active]="
          pathname.includes('/shell/entity-management') &&
          !pathname.startsWith('/shell/entity-management/my-compliance') &&
          !pathname.includes('/shell/entity-management/oig-exclusions')
        ">
        <a routerLink="/shell/entity-management" class="nav-link">
          <i class="fas fa-user-tie nav-icon"></i><span class="nav-text">Employees &amp; Vendors</span>
        </a>
      </li>
      <li *appCheckPolicy="[policyViewOigGlobal]" class="nav-item"
        data-collapsed-label="OIG Exclusions"
        [class.active]="pathname.includes('/shell/entity-management/oig-exclusions')">
        <a routerLink="/shell/entity-management/oig-exclusions" class="nav-link">
          <i class="fas fa-user-slash nav-icon"></i><span class="nav-text">OIG Exclusions</span>
        </a>
      </li>
      </div>
      <div class="nav-group">
        <div class="nav-group-label" aria-hidden="true">Governance &amp; Records</div>
      <li *appCheckPolicyAny="[policyViewPmGlobal, policyViewPmViewPolicies]" class="nav-item"
        data-collapsed-label="Policies &amp; Documents" [class.active]="pathname.includes('/shell/policy-management')">
        <a routerLink="/shell/policy-management" class="nav-link">
          <i class="fas fa-book nav-icon"></i><span class="nav-text">Policies &amp; Documents</span>
        </a>
      </li>
      <!-- *appCheckPolicyAny="[policyViewComplianceGlobal]" -->
      <li *appCheckPolicyAny="[policyViewIncidents, policyViewRaGlobal, policyViewRaViewRiskAssessment]"
        class="nav-item" data-collapsed-label="Compliance Tasks"
        [class.active]="pathname.startsWith('/shell/compliance-management')">
        <a routerLink="/shell/compliance-management" class="nav-link">
          <i class="fas fa-balance-scale nav-icon"></i><span class="nav-text">Compliance Tasks</span>
        </a>
      </li>
      <li
        *appCheckPolicyAny="[policyViewAuditManagementGlobal, policyViewAuditManagementViewAuditPreparation]"
        class="nav-item" data-collapsed-label="Audits"
        [class.active]="pathname.startsWith('/shell/audit-management')">
        <a routerLink="/shell/audit-management" class="nav-link">
          <i class="fas fa-clipboard-check nav-icon"></i>
          <span class="nav-text">Audits</span>
        </a>
      </li>
      <li *appCheckPolicyAny="[policyReportsGlobal, policyReportsViewReports]" class="nav-item"
        data-collapsed-label="Reports" [class.active]="pathname.startsWith('/shell/reports')">
        <a routerLink="/shell/reports" class="nav-link">
          <i class="fas fa-chart-bar nav-icon"></i><span class="nav-text">Reports</span>
        </a>
      </li>
      </div>
      <div class="nav-group">
        <div class="nav-group-label" aria-hidden="true">Settings</div>
      <li *appCheckPolicyAny="[policyViewUmGlobal]" class="nav-item" data-collapsed-label="Team Management"
        [class.active]="
          pathname.startsWith('/shell/user-management') &&
          !pathname.startsWith('/shell/user-management/update-profile')
        ">
        <a routerLink="/shell/user-management" class="nav-link">
          <i class="fas fa-users-cog nav-icon"></i><span class="nav-text">Team Management</span>
        </a>
      </li>
      <li *appCheckPolicyAny="[policyViewSmGlobal]" class="nav-item" data-collapsed-label="Billing &amp; Plan"
        [class.active]="pathname.startsWith('/shell/client-management')">
        <a routerLink="/shell/client-management" class="nav-link">
          <i class="fas fa-credit-card nav-icon"></i><span class="nav-text">Billing &amp; Plan</span>
        </a>
      </li>
      <li class="nav-item" data-collapsed-label="My Profile" [class.active]="
          pathname.startsWith('/shell/user-management/update-profile')
        ">
        <a routerLink="/shell/user-management/update-profile" class="nav-link"
          (click)="router.navigate(['/shell/user-management/update-profile'])">
          <i class="fas fa-user-circle nav-icon"></i><span class="nav-text">My Profile</span>
        </a>
      </li>
      </div>

      <!-- Separator Line Before Sign Out Button -->
      <div class="separator-line"></div>

      <!-- Sign Out Button -->
      <li class="sign-out-btn" data-collapsed-label="Sign Out">
        <button class="outline-button" (click)="logout()">
          <i class="fas fa-sign-out-alt"></i>
          <!-- Font Awesome Icon -->
          <span>Sign Out</span>
        </button>
      </li>
    </ul>

    <button class="floating-hamburger" type="button" (click)="toggleSidebarCollapse()"
      [class.is-collapsed]="isSidebarCollapsed" [attr.aria-label]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'"
      [attr.aria-expanded]="!isSidebarCollapsed">
      <i class="fas fa-angle-double-left"></i>
      <i class="fas fa-angle-double-right"></i>
    </button>
  </nav>

  <!-- Options Bar for Dynamic Components -->
  <div class="options-bar" *ngIf="showOptionsBar">
    <ng-container *ngIf="
        pathname.startsWith('/shell/user-management') &&
        !pathname.startsWith('/shell/user-management/update-profile')
      ">
      <span class="text-option" *appCheckPolicy="[policyViewUsers]" [class.active]="
          pathname === '/shell/user-management' || pathname.includes('users')
        " (click)="router.navigate(['/shell/user-management/users'])">Users</span>
      <span class="text-option" *appCheckPolicy="[policyViewRole]" [class.active]="pathname.includes('roles')"
        (click)="router.navigate(['/shell/user-management/roles'])">Roles</span>
      <span class="text-option" *appCheckPolicy="[policyRolePermission]"
        [class.active]="pathname.includes('permissions')"
        (click)="router.navigate(['/shell/user-management/permissions'])">Permissions</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/client-management')">
      <span class="text-option" *appCheckPolicy="[policyViewSmGlobal, policyViewSubscription]" [class.active]="
          pathname == '/shell/client-management' || pathname.includes('clients')
        " (click)="router.navigate(['/shell/client-management/clients'])">Subscription</span>
      <span class="text-option" *appCheckPolicy="[policyViewSmGlobal, policyViewPayment]"
        [class.active]="pathname.includes('payments')"
        (click)="router.navigate(['/shell/client-management/payments'])">Payments</span>
      <span class="text-option" *appCheckPolicy="[policyViewSmGlobal, policyViewPaymentMethod]"
        [class.active]="pathname.includes('payment-methods')"
        (click)="router.navigate(['/shell/client-management/payment-methods'])">Payment Methods</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/compliance-management')">
      <span *appCheckPolicy="[policyViewRaViewRiskAssessment]" class="text-option"
        [class.active]="pathname.includes('risk-assessment')" (click)="
          router.navigate(['/shell/compliance-management/risk-assessment'])
        ">RA Questions</span>
      <span *appCheckPolicy="[policyViewRaViewRiskAssessment]" class="text-option"
        [class.active]="pathname.includes('risk-results')"
        (click)="router.navigate(['/shell/compliance-management/risk-results'])">RA Results</span>
      <span *appCheckPolicy="[policyViewIncidents]" class="text-option"
        [class.active]="pathname.includes('incident-management')" (click)="
          router.navigate(['/shell/compliance-management/incident-management'])
        ">Incident Management</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('financial-compliance')">
      <span class="text-option" [class.active]="pathname.includes('billing-claims')" (click)="
          router.navigate(['/shell/financial-compliance/billing-claims'])
        ">Billing Claims</span>
      <span class="text-option" [class.active]="pathname.includes('fraud-detection')" (click)="
          router.navigate(['/shell/financial-compliance/fraud-detection'])
        ">Fraud Detection</span>
      <span class="text-option" [class.active]="pathname.includes('medical-coding')" (click)="
          router.navigate(['/shell/financial-compliance/medical-coding'])
        ">Medical Coding</span>
    </ng-container>

    <ng-container *ngIf="
        pathname.startsWith('/shell/entity-management') &&
        !pathname.includes('my-compliance') &&
        !pathname.includes('oig-exclusions')
      ">
      <span class="text-option" *appCheckPolicy="[policyViewEmployees]" [class.active]="pathname.includes('employee')"
        (click)="router.navigate(['/shell/entity-management/employee'])">Employee</span>
      <span class="text-option" *appCheckPolicy="[policyViewVendors]" [class.active]="pathname.includes('vendor')"
        (click)="router.navigate(['/shell/entity-management/vendor'])">Vendor</span>
      <span class="text-option" *appCheckPolicy="[policyViewVendors]" [class.active]="pathname.includes('assets')"
        (click)="router.navigate(['/shell/entity-management/assets'])">Assets</span>
      <span class="text-option" *appCheckPolicyAny="[
          policyScheduleTrainingForVendors,
          policyScheduleTrainingForEmployees
        ]" [class.active]="pathname.includes('trainings') || pathname.includes('schedule-training')" (click)="
          router.navigate(['/shell/entity-management/trainings'])
        ">Trainings</span>
    </ng-container>

    <ng-container *ngIf="pathname.includes('/shell/entity-management/oig-exclusions')">
      <span *appCheckPolicy="[policyViewOigViewEmployee]" class="text-option" [class.active]="pathname.includes('/oig-exclusions/employee')"
        (click)="router.navigate(['/shell/entity-management/oig-exclusions/employee'])">Employee</span>
      <span *appCheckPolicy="[policyViewOigViewVendor]" class="text-option" [class.active]="pathname.includes('/oig-exclusions/vendor')"
        (click)="router.navigate(['/shell/entity-management/oig-exclusions/vendor'])">Vendor</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/policy-management')">
      <span class="text-option" *appCheckPolicy="[policyViewPolicies]"
        [class.active]="pathname == '/shell/policy-management'"
        (click)="router.navigate(['/shell/policy-management'])">All Policies</span>
      <span class="text-option" *appCheckPolicy="[policyViewPolicies]"
        [class.active]="pathname == '/shell/policy-management/acknowledgment'"
        (click)="router.navigate(['/shell/policy-management/acknowledgment'])">Pending Acknowledgment</span>
      <span class="text-option" *appCheckPolicy="[policyViewPolicies]"
        [class.active]="pathname == '/shell/policy-management/documents'"
        (click)="router.navigate(['/shell/policy-management/documents'])">Documents</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/entity-management/my-compliance')">
      <span *appCheckPolicy="[policyViewMpfViewLicences]" class="text-option" [class.active]="
          pathname == '/shell/entity-management/my-compliance' ||
          pathname.includes('licenses')
        " (click)="
          router.navigate(['/shell/entity-management/my-compliance/licenses'])
        ">Licenses</span>
      <span *appCheckPolicy="[policyViewMpfViewAgreements]" class="text-option"
        [class.active]="pathname.includes('agreements')" (click)="
          router.navigate(['/shell/entity-management/my-compliance/agreements'])
        ">Agreements</span>
      <span *appCheckPolicy="[policyViewMpfViewTrainings]" class="text-option"
        [class.active]="pathname.includes('trainings')" (click)="
          router.navigate(['/shell/entity-management/my-compliance/trainings'])
        ">Trainings</span>
      <span *appCheckPolicy="[policyViewMpfViewCertitifications]" class="text-option"
        [class.active]="pathname.includes('certifications')" (click)="
          router.navigate([
            '/shell/entity-management/my-compliance/certifications'
          ])
        ">Certifications</span>
      <span *appCheckPolicy="[policyViewMpfViewComplianceChecks]" class="text-option"
        [class.active]="pathname.includes('compliance-checks')" (click)="
          router.navigate([
            '/shell/entity-management/my-compliance/compliance-checks'
          ])
        ">Compliance checks</span>

      <span *appCheckPolicy="[policyViewMpfViewAssets]" class="text-option" [class.active]="pathname.includes('assets')"
        (click)="
          router.navigate(['/shell/entity-management/my-compliance/assets'])
        ">Assets</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/dashboard')">
      <span
        *appCheckPolicyAny="[policyViewDshGlobal, policyViewDshGeneralView, policyViewDshVendor, policyViewDshEmployee, policyViewDshPolicies, policyViewDshUserAudits, policyViewDshIncidentsNotifications, policyViewDshIncidents, policyViewDshAssets]"
        class="text-option" [class.active]="
          pathname == '/shell/dashboard/my-charts' || pathname == '/shell/dashboard'
        " (click)="router.navigate(['/shell/dashboard'])">Dashboard</span>
      <span *appCheckPolicy="[policyViewDshVendor]" class="text-option"
        [class.active]="pathname.includes('vendor-charts')"
        (click)="router.navigate(['/shell/dashboard/vendor-charts'])">Vendors</span>
      <span *appCheckPolicy="[policyViewDshEmployee]" class="text-option"
        [class.active]="pathname.includes('employee-charts')"
        (click)="router.navigate(['/shell/dashboard/employee-charts'])">Employees</span>
      <span *appCheckPolicy="[policyViewDshPolicies]" class="text-option"
        [class.active]="pathname.includes('policy-charts')"
        (click)="router.navigate(['/shell/dashboard/policy-charts'])">Policies</span>
      <span *appCheckPolicy="[policyViewDshUserAudits]" class="text-option"
        [class.active]="pathname.includes('user-audit-charts')"
        (click)="router.navigate(['/shell/dashboard/user-audit-charts'])">User Audits</span>
      <span *appCheckPolicy="[policyViewDshIncidents]" class="text-option"
        [class.active]="pathname.includes('incident-charts')"
        (click)="router.navigate(['/shell/dashboard/incident-charts'])">Incidents</span>

      <span *appCheckPolicy="[policyViewDshIncidentsNotifications]" class="text-option"
        [class.active]="pathname.includes('incident-notification-charts')" (click)="
          router.navigate(['/shell/dashboard/incident-notification-charts'])
        ">Incident Notifications</span>

      <span *appCheckPolicy="[policyViewDshAssets]" class="text-option"
        [class.active]="pathname.includes('asset-charts')"
        (click)="router.navigate(['/shell/dashboard/asset-charts'])">Assets</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/audit-management')">
      <span *appCheckPolicyAny="[policyViewAuditManagementViewAuditPreparation]" class="text-option"
        routerLink="/shell/audit-management/audit-preparation" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">
        Audit Preparation
      </span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/koursebox')">
      <span class="text-option" [class.active]="pathname.includes('/player')"
        (click)="router.navigate(['/shell/koursebox/player'])">Player</span>
      <span class="text-option" [class.active]="pathname.includes('/marketplace')"
        (click)="router.navigate(['/shell/koursebox/marketplace'])">Marketplace</span>
      <span class="text-option" [class.active]="pathname.includes('/admin')"
        (click)="router.navigate(['/shell/koursebox/admin'])">Admin</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/user-management/update-profile')">
      <span class="text-option" [class.active]="pathname.includes('update-profile')"
        (click)="router.navigate(['/shell/user-management/update-profile'])">User Profile</span>
    </ng-container>

    <ng-container *ngIf="pathname.startsWith('/shell/reports')">
      <span *appCheckPolicy="[policyReportsViewReports]" class="text-option"
        [class.active]="pathname == '/shell/reports'">Reports</span>
    </ng-container>
  </div>

  <!-- Floating Notification Button -->
  <button class="floating-notification-burger" type="button" (click)="toggleNotificationPanel($event)"
    [attr.aria-expanded]="isNotificationBarVisible">
    <i class="fas fa-bell"></i>
    <span class="notification-badge" *ngIf="unreadNotificationCount > 0">
      {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
    </span>
  </button>

  <aside class="notification-bar" [class.open]="isNotificationBarVisible">
    <div class="notification-panel-header" *ngIf="isMobile">
      <span class="notification-panel-title">Notifications</span>
      <button class="notification-panel-close" type="button" (click)="toggleNotificationPanel($event)"
        aria-label="Close notifications panel">
        ×
      </button>
    </div>

    <div class="notification-empty" *ngIf="unreadNotificationCount === 0">
      <div class="notification-empty-icon" aria-hidden="true">
        <i class="fas fa-check-circle"></i>
      </div>
      <p class="notification-empty-title">You're all caught up</p>
      <p class="notification-empty-subtitle">No pending notifications right now.</p>
    </div>
    <div class="notification-toolbar" *ngIf="unreadNotificationCount > 0">
      <div class="clear-all-control" [class.is-expanded]="isClearAllConfirmVisible">
        <button *ngIf="!isClearAllConfirmVisible" class="clear-all-btn" type="button"
          (click)="toggleClearAllConfirmation($event)" [disabled]="isClearAllPending"
          [attr.aria-expanded]="isClearAllConfirmVisible">
          <i class="fas fa-trash-alt" aria-hidden="true"></i>
          <span>{{ isClearAllPending ? 'Clearing...' : 'Clear all' }}</span>
        </button>
        <div class="clear-all-confirm" *ngIf="isClearAllConfirmVisible">
          <span class="clear-all-confirm-text">Are you sure?</span>
          <button class="clear-all-confirm-btn confirm-yes" type="button" (click)="confirmClearAllNotifications($event)"
            [disabled]="isClearAllPending">
            Yes
          </button>
          <button class="clear-all-confirm-btn confirm-no" type="button" (click)="cancelClearAllConfirmation($event)"
            [disabled]="isClearAllPending">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let n of notifications">
      <div class="notification" *ngIf="!n.readAt" [@notificationItem]
        [ngClass]="getNotificationSeverityClass(n.severity)">
        <div class="icon-section">
          <i class="notification-icon fas fa-info-circle">
          </i>
        </div>

        <div class="notification-content">
          <button class="close-button" (click)="removeNotification(n.id, $event)"
            [disabled]="isNotificationRemovalPending(n.id) || isClearAllPending">
            ×
          </button>
          <strong>{{ n.title }}</strong>
          <span>{{ n.summary }}</span>
          <div class="notification-meta">
            <small>{{ n.createdAt | date : "short" }}</small>
          </div>
        </div>
      </div>
    </ng-container>
  </aside>

  <!-- Main Content Area -->
  <main class="content">
    <router-outlet></router-outlet>
    <!-- Angular Router Outlet for dynamic components -->
  </main>

  <!-- Footer -->
  <footer class="footer">
    <div class="footer-logo">
      <i class="fas fa-shield-alt"></i>
      <!-- Logo Icon -->
      <span>&copy; {{ currentYear }} Complydome all rights reserved.</span>
      <!-- Logo Text -->
    </div>
    <div class="footer-links">
      <a href="#" (click)="openPopup('privacy'); $event.preventDefault()">
        Privacy Policy
      </a>

      <a href="#" (click)="openPopup('service'); $event.preventDefault()">
        Terms of Service
      </a>
      <a href="#" (click)="openPopup('accessibility'); $event.preventDefault()">
        Accessibility
      </a>
      <a href="#" (click)="displayCreateNewTicketModal(); $event.preventDefault()">
        Contact Us
      </a>
    </div>
  </footer>

  <!-- Legal Popups -->
  <app-legal-popups [popup]="popup" (close)="closePopup()"></app-legal-popups>

  <!-- AI Assistant Component -->
  <app-ai-assistant></app-ai-assistant>
</div>
